export const extinctNullFromParams = <T extends Record<string, unknown>>(
  params: T
): ExtinctNull<T> => {
  const extinctedParams: Record<string, unknown> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }
    extinctedParams[key] = value;
  });
  return extinctedParams as ExtinctNull<T>;
};

type ExtinctNull<T> = Identity<
  {
    [K in keyof T as [IsSomeNullable<T[K]>] extends [never] ? K : never]: T[K];
  } & {
    [K in keyof T as [IsSomeNullable<T[K]>] extends [never]
      ? never
      : K]?: NonNullable<T[K]>;
  }
>;
type IsSomeNullable<T> = T extends null ? true : never;
type Identity<T> = T extends object ? object & { [P in keyof T]: T[P] } : T;

export const extinctFalsyFromParams = (
  params: Record<string, unknown>,
  allowKeys?: string[]
) => {
  const extinctedParams: Record<string, unknown> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (allowKeys?.includes(key)) {
      extinctedParams[key] = value;
    }
    if (!value) {
      return;
    }
    if (Array.isArray(value) && value.length === 0) {
      return;
    }
    extinctedParams[key] = value;
  });
  return extinctedParams;
};
